import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  request: {
    isLoading: boolean;
    error: string | null;
  };
  list: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
  one: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
}

const initialState: InitialStateProps = {
  request: {
    isLoading: false,
    error: null,
  },
  list: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
  one: {
    isLoading: false,
    data: null,
    error: null,
  },
};

export const { actions: userActions, reducer: userReducer } = createSlice({
  name: 'region',
  initialState,
  reducers: {
    //Request
    setUserRequestStart: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setUserRequestSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setUserRequestFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },
    setUserRequestDefault: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    //List
    setUserListRequest: (state) => {
      state.list = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setUserListSuccess: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setUserListFailure: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setUserListDefault: (state) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },
    //One
    setUserOneRequest: (state) => {
      state.one = {
        isLoading: true,
        data: null,
        error: null,
      };
    },
    setUserOneSuccess: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setUserOneFailure: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
    setUserOneDefault: (state) => {
      state.one = {
        isLoading: false,
        data: null,
        error: null,
      };
    },
  },
});
